<template>
	<div>
		<v-toolbar
			color="secondary"
			dark
			tabs
			height="100px"
		>
			<v-container
				py-o
				my-0
			>
				<v-toolbar-title class="display-2 ma-0">Error</v-toolbar-title>
			</v-container>
		</v-toolbar>
		<v-container
			grid-list-xl
		>
			<v-layout
				row
				wrap
				justify-center
				align-center
				class="text-xs-center"
			>
				<v-flex
					xs12
					md8
				>
					<v-card class="pa-4">
						<div class="headline error--text mb-2">Sorry, an error occured.</div>
						<div class="subheading mb-4">Try to reload the application, visit support page, or contact our support.</div>
						<v-btn
							flat
							color="info"
							@click="goBack()"
						>
							<v-icon left>arrow_back</v-icon>
							{{ backText }}
						</v-btn>
						<v-btn
							flat
							color="info"
							href="https://support.reportmule.com/en"
							target="_blank"
						>
							<v-icon left>language</v-icon>
							Visit support website
						</v-btn>
						<v-btn
							flat
							color="info"
							href="mailto:support@reportmule.com"
						>
							<v-icon left>email</v-icon>
							Contact support
						</v-btn>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
export default {
	data() {
		return {
			backText: 'Take Me Back',
		};
	},
	created() {
		if (this.$route.params.to) {
			this.backText = 'Take Me Home';
		}
	},
	methods: {
		goBack() {
			if (this.$route.params.to) {
				this.$router.replace(this.$route.params.to);
			}
			else {
				this.$router.back();
			}
		},
	},
};
</script>

<style>

</style>
